module.exports = __webpack_public_path__ + "static/background-06eb306b0264ab467d5b30f67dad8144.png";